import { render, staticRenderFns } from "./DistrictList.vue?vue&type=template&id=e78ff76e&"
import script from "./DistrictList.vue?vue&type=script&lang=js&"
export * from "./DistrictList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports